module.exports = __webpack_public_path__ + "img/logo-branco-estacio.6d55ca21.svg";